import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import Global from "../../util/Global";
import { useTranslation } from "react-i18next";
import { LoaderComponent } from "../../util/Loader";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { AlertContext } from "../../util/Alerter";
import { InputAdornment, TextField } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LockResetIcon from '@mui/icons-material/LockReset';


const changerpassword = Global.backend + "/index.php/api/user/editPassword";



const ChangerMotPasse = () => {
  const [isLoading, setisLoading] = useState(false)
  const [currentPassword, setcurrentPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const { showAlert } = useContext(AlertContext)
  const { t } = useTranslation();
  const [errors, setErrors] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  })



  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)


  useEffect(() => {
    setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
    setpageTitle("changePassword")
    setalertTitle("")
    setnavLinks([])
  }, [])







  const checkInputs = () => {
    const errors = {
      currentPassword: false,
      newPassword: newPassword == currentPassword,
      confirmPassword: confirmPassword != newPassword
    };

    setErrors(errors)



    const hasErrors = Object.values(errors).some(error => error)

    if (hasErrors) {
      let errorMessage = ""


      if (errors.newPassword) {
        errorMessage = t("user.verifyNewPassword")
      } else if (errors.confirmPassword) {
        errorMessage = t("user.verifyConfirmPassword")
      }

      showAlert("error", errorMessage)
    }


    return !hasErrors
  }




  function onSubmit() {
    if (!checkInputs()) {
      return
    }

    setisLoading(true)


    axios
      .post(changerpassword, {
        password: currentPassword,
        newpassword: newPassword,
      })
      .then((response) => {
        if (response.data.message == "ok") {
          setcurrentPassword("")
          setnewPassword("")
          setconfirmPassword("")

          showAlert("success", t("request.successChangingPassword"))
        } else {
          showAlert("error", t("user.verifyCurrentPassword"))
          setErrors({
            currentPassword: true,
            newPassword: false,
            confirmPassword: false
          })
        }
      }).catch((error) => {
        showAlert("error", t("request.errorChangingPassword"))
      })
      .finally(() => {
        setisLoading(false)
      });
  }









  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading &&

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">


              <div className="card">
                <div className="card-body">
                  <div
                    id="addproduct-nav-pills-wizard"
                    className="twitter-bs-wizard"
                  >

                    <div className="tab-pane" id="basic-info">



                      <h4 className="card-title">{t("changePassword")}</h4>
                      <p className="card-title-desc"></p>


                      <div className="row mb-3">
                        <div className="col-4">
                          <TextField value={currentPassword} error={errors.currentPassword} fullWidth variant="outlined" type="text" label={t("user.currentPassword")} onChange={(e) => setcurrentPassword(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <LockIcon />
                                </InputAdornment>
                              )
                            }} />
                        </div>
                        <div className="col-4">
                          <TextField value={newPassword} error={errors.newPassword} fullWidth variant="outlined" type="text" label={t("user.newPassword")} onChange={(e) => setnewPassword(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <VpnKeyIcon />
                                </InputAdornment>
                              )
                            }} />
                        </div>
                        <div className="col-4">
                          <TextField value={confirmPassword} error={errors.confirmPassword} fullWidth variant="outlined" type="text" label={t("user.confirmPassword")} onChange={(e) => setconfirmPassword(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <LockResetIcon />
                                </InputAdornment>
                              )
                            }} />
                        </div>
                      </div>
                    </div>





                    <div
                      className="tab-pane"
                      id="metadata"
                      style={{ cursor: "pointer" }}
                    >
                      <ul className="pager wizard twitter-bs-wizard-pager-link">
                        <li
                          className="float-end"
                          style={{ cursor: "pointer" }}
                        >

                          <a onClick={() => { onSubmit() }}>
                            {t("save")}
                            <i className="mdi mdi-arrow-right ml-1"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>






            </div>
          </div>
        </div>
      }
    </LoaderComponent>
  );
};

export default ChangerMotPasse;
